import { IonCol, IonGrid, IonRow, IonText } from '@ionic/react';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import TertiaryButton from '@components/buttons/TertiaryButton';
import styles from '@components/Question.module.css';
import Icon from '@components/text/Icon';
import { CareProfileActionableFieldEnum } from '@typing/Generated';
import { PersonalizeExperienceFields } from '@typing/Models';
import { IconName } from '@utils/iconUtils';

type Props = {
  field?: PersonalizeExperienceFields | CareProfileActionableFieldEnum;
  handleEdit?: (field: PersonalizeExperienceFields) => () => void;
  icon?: IconName | null;
  selections: (string | ReactNode | ReactNode[] | null)[];
};

const PMEQuestion = ({ field, handleEdit, icon, selections }: Props) => (
  <div className={styles.questionWrapper}>
    <IonGrid className="ion-no-padding">
      <IonRow className="ion-align-items-center">
        <IonCol className="ion-margin-end">
          <IonText className={styles.question}>
            {field && <FormattedMessage id={`models.pme.questions.${field}.content`} />}
          </IonText>
        </IonCol>
        {handleEdit && (
          <IonCol data-test="edit" size="auto">
            <TertiaryButton
              icon="edit"
              onClick={handleEdit(field as PersonalizeExperienceFields)}
              textKey="dictionary.edit"
            />
          </IonCol>
        )}
      </IonRow>
    </IonGrid>
    {selections.map(selection => (
      <div className={styles.selection} key={selection?.toString()}>
        {icon && <Icon ariaLabelKey="accessibility.ariaLabels.questionIcon" className={styles.icon} icon={icon} />}
        <IonText className={styles.text}>{selection}</IonText>
      </div>
    ))}
  </div>
);
export default PMEQuestion;
